import React, { useEffect, useState, Fragment, lazy, createElement, Component } from 'react';
import { Check, ChevronDown, Star, ShieldCheck, Clock, Download, ArrowRight, X, Brain, Target, Zap, Users, MessageSquare, Eye, Trophy, Repeat, AlertCircle, Timer, UsersRound } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
// --- Meta Pixel Component ---
const MetaPixel = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '26257470350562748');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=26257470350562748&ev=PageView&noscript=1" />`;
    document.head.appendChild(noscript);
  }, []);
  return null;
};
// --- Fake Purchase Popup Component ---
const FakePurchasePopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [purchaseData, setPurchaseData] = useState({
    name: '',
    city: ''
  });
  const firstNames = ['Martín', 'Lucas', 'Diego', 'Facundo', 'Julián', 'Tomás', 'Nicolás', 'Matías', 'Federico', 'Gonzalo', 'Agustín', 'Sebastián', 'Emanuel', 'Joaquín', 'Bruno'];
  const lastNames = ['Rossi', 'Fernández', 'Silva', 'Gómez', 'Álvarez', 'Martínez', 'Pérez', 'Romero', 'Sosa', 'Acosta', 'Benítez', 'Cabrera', 'Quiroga', 'Ledesma', 'Ferrari'];
  const cities = ['Rosario, Santa Fe', 'Córdoba, Córdoba', 'CABA, Buenos Aires', 'La Plata, Buenos Aires', 'Mendoza, Mendoza', 'Mar del Plata, Buenos Aires', 'San Miguel de Tucumán, Tucumán', 'Salta, Salta', 'Neuquén, Neuquén', 'Bahía Blanca, Buenos Aires', 'Posadas, Misiones', 'Resistencia, Chaco', 'Santa Fe, Santa Fe', 'San Juan, San Juan', 'Paraná, Entre Ríos'];
  const rand = (arr: string[]) => arr[Math.floor(Math.random() * arr.length)];
  useEffect(() => {
    const showPopup = () => {
      setPurchaseData({
        name: `${rand(firstNames)} ${rand(lastNames)}`,
        city: rand(cities)
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 6000);
    // Recurring
    const interval = setInterval(() => {
      showPopup();
    }, 18000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-0">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-xl shadow-2xl border border-gray-100 overflow-hidden max-w-xs w-[calc(100%-2rem)] sm:w-full" data-id="element-1">
          <div className="bg-green-500 px-3 py-1.5 flex items-center justify-between" data-id="element-2">
            <span className="flex items-center text-white text-xs font-extrabold tracking-wide" data-id="element-3">
              <Check size={14} className="mr-1.5" strokeWidth={3} data-id="element-4" />
              COMPRA VERIFICADA
            </span>
            <button onClick={() => setIsVisible(false)} aria-label="Cerrar notificación" className="text-white/80 hover:text-white" data-id="element-5">
              <X size={14} data-id="element-6" />
            </button>
          </div>
          <div className="p-4 flex items-center gap-3" data-id="element-7">
            <div className="w-10 h-10 rounded-full bg-neutral-900 text-green-400 flex items-center justify-center font-bold text-sm flex-shrink-0" data-id="element-8">
              {purchaseData.name.split(' ').map(n => n[0]).join('')}
            </div>
            <div className="min-w-0" data-id="element-9">
              <p className="text-sm text-gray-900 font-semibold leading-tight" data-id="element-10">
                {purchaseData.name}
              </p>
              <p className="text-xs text-gray-500 truncate" data-id="element-11">
                {purchaseData.city}
              </p>
              <p className="text-[11px] text-gray-400 mt-0.5" data-id="element-12">
                compró el KIT · hace unos minutos
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
};
// --- Countdown Timer (counts down to the end of today / next midnight) ---
const CountdownTimer = () => {
  const getTimeLeft = () => {
    const now = new Date();
    const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
    const diff = Math.max(0, endOfDay.getTime() - now.getTime());
    const totalSeconds = Math.floor(diff / 1000);
    return {
      hours: Math.floor(totalSeconds / 3600),
      minutes: Math.floor(totalSeconds % 3600 / 60),
      seconds: totalSeconds % 60
    };
  };
  const [timeLeft, setTimeLeft] = useState(getTimeLeft());
  useEffect(() => {
    const interval = setInterval(() => setTimeLeft(getTimeLeft()), 1000);
    return () => clearInterval(interval);
  }, []);
  const pad = (n: number) => String(n).padStart(2, '0');
  const units = [{
    label: 'Horas',
    value: pad(timeLeft.hours)
  }, {
    label: 'Min',
    value: pad(timeLeft.minutes)
  }, {
    label: 'Seg',
    value: pad(timeLeft.seconds)
  }];
  return <div className="bg-red-600 text-white rounded-xl px-4 py-3 text-center shadow-lg" data-id="element-13">
      <p className="text-xs font-bold uppercase tracking-wide mb-2 flex items-center justify-center" data-id="element-14">
        <Clock size={14} className="mr-1.5" data-id="element-15" />
        La oferta termina en:
      </p>
      <div className="flex items-center justify-center gap-2" data-id="element-16">
        {units.map((u, i) => <Fragment key={u.label} data-id="element-17">
            <div className="flex flex-col items-center" data-id="element-18">
              <span className="bg-red-800/60 rounded-md px-2.5 py-1.5 text-2xl font-display font-bold tabular-nums min-w-[2.6rem]" data-id="element-19">
                {u.value}
              </span>
              <span className="text-[10px] uppercase mt-1 opacity-90" data-id="element-20">
                {u.label}
              </span>
            </div>
            {i < units.length - 1 && <span className="text-2xl font-bold -mt-3" data-id="element-21">:</span>}
          </Fragment>)}
      </div>
    </div>;
};
// --- FAQ Component ---
const FAQItem = ({
  question,
  answer
}: {
  question: React.ReactNode;
  answer: React.ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 py-4" data-id="element-22">
      <button className="flex justify-between items-center w-full text-left font-semibold text-gray-800 focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-23">
        <span className="pr-4" data-id="element-24">{question}</span>
        <ChevronDown className={`transform transition-transform duration-200 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} size={20} data-id="element-25" />
      </button>
      <AnimatePresence data-id="element-26">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="overflow-hidden" data-id="element-27">
            <div className="pt-3 text-gray-600 text-sm leading-relaxed" data-id="element-28">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
};
export function App() {
  const scrollToCheckout = (e: React.MouseEvent) => {
    e.preventDefault();
    const checkoutSection = document.getElementById('checkout-section');
    if (checkoutSection) {
      checkoutSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  const productImageUrl = 'https://cdn.magicpatterns.com/uploads/r5WftmVjk2PC8S4XzRnYr1/Diseno_sin_titulo_(40).png';
  const checkoutLink = 'https://checkout.sectordigital.online/cart/44241090576427:1';
  return <div className="min-h-screen bg-neutral-50 font-sans text-gray-800 selection:bg-green-200" data-id="element-29">
      <MetaPixel data-id="element-30" />
      <FakePurchasePopup data-id="element-31" />

      {/* HEADER / HERO */}
      <header className="bg-neutral-900 text-white min-h-[100svh] md:min-h-0 flex flex-col justify-center py-8 md:py-20 px-4 relative overflow-hidden" data-id="element-32">
        <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none" style={{
        backgroundImage: 'radial-gradient(#22c55e 1px, transparent 1px)',
        backgroundSize: '30px 30px'
      }} data-id="element-33"></div>
        <div className="max-w-4xl mx-auto text-center relative z-10 w-full" data-id="element-34">
          <p className="text-green-400 font-bold tracking-widest text-[11px] md:text-sm mb-6 md:mb-4 uppercase" data-id="element-35">
            EL SISTEMA COMPROBADO PARA TUS SESIONES CON FUTBOLISTAS.
          </p>
          <h1 className="text-3xl md:text-6xl font-display font-bold mb-7 md:mb-6 leading-tight" data-id="element-36">
            KIT Psicología en Fútbol™
          </h1>

          <div className="flex flex-col md:flex-row items-center justify-center gap-8 mb-7 md:mb-6" data-id="element-37">
            <img src={productImageUrl} alt="KIT Psicología en Fútbol" decoding="async" className="w-[45%] md:w-[70%] max-w-[200px] md:max-w-[320px] drop-shadow-2xl cursor-pointer hover:scale-105 transition-transform duration-300" onClick={scrollToCheckout} data-id="element-38" />
          </div>

          <p className="text-sm md:text-2xl text-gray-300 mb-8 md:mb-10 max-w-2xl mx-auto font-light leading-relaxed" data-id="element-39">
            Sistema completo para trabajar el rendimiento mental del futbolista
            desde el entrenamiento hasta la competencia.
          </p>

          <button onClick={scrollToCheckout} className="bg-green-500 hover:bg-green-400 text-neutral-900 font-bold text-base md:text-xl py-3.5 md:py-4 px-8 rounded-full shadow-[0_0_30px_rgba(34,197,94,0.4)] hover:shadow-[0_0_40px_rgba(34,197,94,0.6)] transition-all transform hover:-translate-y-1 flex items-center justify-center mx-auto w-full max-w-md" data-id="element-40">
            SÍ, QUIERO EL KIT AHORA
            <ArrowRight className="ml-2" data-id="element-41" />
          </button>

          <div className="flex flex-wrap justify-center gap-4 md:gap-4 mt-7 md:mt-6 text-xs md:text-sm text-gray-400" data-id="element-42">
            <span className="flex items-center" data-id="element-43">
              <Download size={16} className="mr-1" data-id="element-44" /> Acceso inmediato
            </span>
            <span className="flex items-center" data-id="element-45">
              <ShieldCheck size={16} className="mr-1" data-id="element-46" /> Pago único y seguro
            </span>
          </div>
          <p className="mt-6 md:mt-4 text-xs md:text-base text-gray-300 italic" data-id="element-47">
            Descargás. Aplicás. Trabajás con más seguridad profesional.
          </p>
        </div>
      </header>

      {/* UN SISTEMA QUE TE DA DIRECCIÓN */}
      <section className="py-20 px-4 bg-neutral-100" data-id="element-48">
        <div className="max-w-4xl mx-auto" data-id="element-49">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-center text-neutral-900" data-id="element-50">
            UN SISTEMA QUE TE DA DIRECCIÓN EN CADA SITUACIÓN DEL JUEGO
          </h2>
          <p className="text-center text-xl text-gray-600 mb-12 font-medium" data-id="element-51">
            KIT Psicología en Fútbol™ | Método Mente de Juego™
          </p>

          <p className="text-lg text-center max-w-2xl mx-auto mb-16 text-gray-700" data-id="element-52">
            Un sistema práctico para evaluar, planificar e intervenir el
            rendimiento mental del futbolista con una estructura pensada para
            las situaciones reales del fútbol.
          </p>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-53">
            <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-54">
              <div className="w-12 h-12 bg-green-100 text-green-600 rounded-full flex items-center justify-center mb-6" data-id="element-55">
                <ShieldCheck size={24} data-id="element-56" />
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-57">
                MÁS SEGURIDAD PROFESIONAL
              </h3>
              <p className="text-gray-600" data-id="element-58">
                Entrás a sesión sabiendo exactamente cómo intervenir cuando el
                jugador se bloquea, pierde confianza o no logra rendir como
                entrena.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-59">
              <div className="w-12 h-12 bg-green-100 text-green-600 rounded-full flex items-center justify-center mb-6" data-id="element-60">
                <Check size={24} data-id="element-61" />
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-62">
                MÁS ORDEN EN CADA PROCESO
              </h3>
              <p className="text-gray-600" data-id="element-63">
                Dejás de improvisar frente a situaciones de error, presión, DT,
                equipo y competencia.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-64">
              <div className="w-12 h-12 bg-green-100 text-green-600 rounded-full flex items-center justify-center mb-6" data-id="element-65">
                <Star size={24} data-id="element-66" />
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-67">
                ESTRUCTURA ESPECÍFICA PARA FÚTBOL
              </h3>
              <p className="text-gray-600" data-id="element-68">
                Herramientas, protocolos y plantillas diseñadas para las
                situaciones mentales reales del juego.
              </p>
            </div>
          </div>

          <div className="mt-16 text-center" data-id="element-69">
            <button onClick={scrollToCheckout} className="bg-neutral-900 hover:bg-neutral-800 text-white font-bold text-lg py-4 px-8 rounded-full transition-all transform hover:-translate-y-1 inline-flex items-center" data-id="element-70">
              QUIERO ESTA ESTRUCTURA
              <ArrowRight className="ml-2" size={20} data-id="element-71" />
            </button>
          </div>
        </div>
      </section>

      {/* BLOQUE MÓDULOS */}
      <section className="py-20 px-4 bg-white" data-id="element-72">
        <div className="max-w-3xl mx-auto" data-id="element-73">
          <div className="text-center mb-12" data-id="element-74">
            <div className="inline-block bg-blue-100 text-blue-800 font-bold px-3 py-1 rounded-full text-sm mb-4" data-id="element-75">
              BLOQUE MÓDULOS
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-neutral-900 mb-4" data-id="element-76">
              QUÉ INCLUYE EL KIT PSICOLOGÍA EN FÚTBOL™
            </h2>
            <p className="text-xl text-gray-600" data-id="element-77">
              Método Mente de Juego™ — 8 módulos profesionales:
            </p>
          </div>

          <div className="bg-neutral-50 rounded-2xl border border-neutral-200 overflow-hidden shadow-sm" data-id="element-78">
            {[{
            title: '1. Perfil mental del futbolista',
            desc: 'Evaluación del estado mental del jugador.',
            icon: <Brain size={20} data-id="element-79" />
          }, {
            title: '2. Manejo del error en la cancha',
            desc: 'Protocolo para trabajar la respuesta psicológica al error durante el juego.',
            icon: <AlertCircle size={20} data-id="element-80" />
          }, {
            title: '3. Presión del resultado y miedo a fallar',
            desc: 'Penales, definiciones, finales, clásicos y situaciones de alta exposición.',
            icon: <Target size={20} data-id="element-81" />
          }, {
            title: '4. Dinámica de equipo y cohesión grupal',
            desc: 'Comunicación, roles, liderazgo, conflictos internos y respuesta grupal bajo presión.',
            icon: <Users size={20} data-id="element-82" />
          }, {
            title: '5. Relación con el DT y el cuerpo técnico.',
            desc: 'Críticas, suplencia, falta de minutos y presión por demostrar.',
            icon: <MessageSquare size={20} data-id="element-83" />
          }, {
            title: '6. Concentración y foco en el juego',
            desc: 'Gestión de distractores internos y externos dentro del partido.',
            icon: <Eye size={20} data-id="element-84" />
          }, {
            title: '7. Preparación mental para la competencia.',
            desc: 'Activación, visualización, ansiedad competitiva y preparación específica del fútbol.',
            icon: <Trophy size={20} data-id="element-85" />
          }, {
            title: '8. Trabajo mental en el entrenamiento diario',
            desc: 'Protocolo para integrar el trabajo psicológico en la rutina semanal y transferirlo al partido.',
            icon: <Repeat size={20} data-id="element-86" />
          }].map((mod, i) => <FAQItem key={i} question={<div className="flex items-center gap-3" data-id="element-88">
                    <div className="bg-green-100 text-green-600 w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-89">
                      {mod.icon}
                    </div>
                    <span className="font-bold text-neutral-900" data-id="element-90">
                      {mod.title.replace(/^\d+\.\s/, '')}
                    </span>
                  </div>} answer={<div className="pl-11 text-gray-600 text-sm" data-id="element-91">{mod.desc}</div>} data-id="element-87" />)}
          </div>
        </div>
      </section>

      {/* ESTE KIT ES PARA VOS SI... */}
      <section className="py-20 px-4 bg-neutral-900 text-white" data-id="element-92">
        <div className="max-w-3xl mx-auto" data-id="element-93">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center text-green-400" data-id="element-94">
            ESTE KIT ES PARA VOS SI...
          </h2>

          <div className="space-y-6" data-id="element-95">
            {['Querés trabajar con futbolistas y necesitás una estructura específica para fútbol.', 'Ya trabajás en psicología deportiva pero tus herramientas son demasiado generales para las situaciones reales del juego.', 'Te cuesta intervenir cuando un jugador se bloquea después de un error.', 'Querés trabajar presión, penales y miedo a fallar con más claridad.', 'Necesitás recursos para trabajar relación con DT, suplencia y críticas.', 'Querés intervenir con equipos sin caer en charlas motivacionales vacías.'].map((item, i) => <div key={i} className="flex items-center bg-neutral-800 p-5 rounded-lg border border-neutral-700" data-id="element-96">
                <Check className="text-green-400 mr-4 flex-shrink-0" size={24} data-id="element-97" />
                <span className="text-lg font-medium" data-id="element-98">{item}</span>
              </div>)}
          </div>
        </div>
      </section>

      {/* BONUS */}
      <section className="py-20 px-4 bg-neutral-100" data-id="element-99">
        <div className="max-w-5xl mx-auto" data-id="element-100">
          <div className="text-center mb-12" data-id="element-101">
            <h2 className="text-3xl md:text-5xl font-display font-bold text-neutral-900 mb-4 uppercase tracking-wide" data-id="element-102">
              BONUS PROFESIONALES
            </h2>
            <div className="inline-flex items-center bg-yellow-100 text-yellow-800 px-4 py-2 rounded-full font-bold text-lg animate-pulse" data-id="element-103">
              <Clock size={20} className="mr-2" data-id="element-104" />
              GRATIS POR EL DÍA DE HOY
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-105">
            {[{
            n: 'BONUS #1',
            icon: <Brain size={20} data-id="element-106" />,
            img: 'https://images.unsplash.com/photo-1543326727-cf6c39e8f84c?w=480&q=60&auto=format&fit=crop',
            alt: 'Futbolista cabizbajo tras una mala jugada',
            title: 'PROTOCOLO MENTAL POST ERROR',
            desc: 'Guía para trabajar con futbolistas que se caen mentalmente después de una mala jugada.',
            incluye: 'cadena error → pensamiento → emoción → conducta; técnica de reset mental; palabra clave post error; cómo volver a pedir la pelota; ejercicio práctico para sesión.'
          }, {
            n: 'BONUS #2',
            icon: <Timer size={20} data-id="element-107" />,
            img: 'https://images.unsplash.com/photo-1551958219-acbc608c6377?w=480&q=60&auto=format&fit=crop',
            alt: 'Pelota de fútbol en el césped de la cancha antes del partido',
            title: 'RUTINA PRE PARTIDO PARA FUTBOLISTAS',
            desc: 'Material para construir una rutina mental antes de competir.',
            incluye: 'preparación el día anterior; rutina de vestuario; activación mental; visualización breve; palabra clave y primera acción del partido.'
          }, {
            n: 'BONUS #3',
            icon: <UsersRound size={20} data-id="element-108" />,
            img: 'https://images.unsplash.com/photo-1522778119026-d647f0596c20?w=480&q=60&auto=format&fit=crop',
            alt: 'Equipo de fútbol reunido en grupo',
            title: 'GUÍA DE REUNIÓN GRUPAL PARA EQUIPOS',
            desc: 'Recurso para dirigir intervenciones grupales con planteles.',
            incluye: 'apertura de reunión; acuerdos de comunicación; respuesta colectiva al error; mini dinámica grupal; cierre con compromiso de equipo.'
          }].map((bonus, i) => <div key={i} className="bg-white rounded-2xl shadow-lg border-2 border-yellow-400 relative overflow-hidden flex flex-col" data-id="element-109">
                <div className="relative h-32 w-full overflow-hidden bg-neutral-200" data-id="element-110">
                  <img src={bonus.img} alt={bonus.alt} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-111" />
                  <div className="absolute inset-0 bg-neutral-900/30" data-id="element-112" />
                  <div className="absolute top-0 right-0 bg-yellow-400 text-yellow-900 font-bold px-3 py-1 rounded-bl-lg text-xs" data-id="element-113">
                    {bonus.n}
                  </div>
                  <div className="absolute -bottom-5 left-5 w-11 h-11 bg-yellow-400 text-yellow-900 rounded-full flex items-center justify-center shadow-md ring-4 ring-white" data-id="element-114">
                    {bonus.icon}
                  </div>
                </div>
                <div className="p-5 pt-7 flex flex-col flex-grow" data-id="element-115">
                  <h3 className="text-lg font-bold mb-2 text-neutral-900 leading-tight" data-id="element-116">
                    {bonus.title}
                  </h3>
                  <p className="text-gray-600 mb-3 text-sm font-medium flex-grow" data-id="element-117">
                    {bonus.desc}
                  </p>
                  <div className="bg-neutral-50 p-3 rounded-lg text-xs text-gray-700 leading-relaxed" data-id="element-118">
                    <strong data-id="element-119">Incluye:</strong> {bonus.incluye}
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* CHECKOUT SECTION */}
      <section id="checkout-section" className="py-10 px-4 bg-white border-t border-gray-100" data-id="element-120">
        <div className="max-w-4xl mx-auto" data-id="element-121">
          <div className="bg-neutral-900 rounded-3xl overflow-hidden shadow-2xl flex flex-col md:flex-row" data-id="element-122">
            <div className="md:w-1/2 p-6 bg-neutral-800 flex flex-col justify-center items-center text-center" data-id="element-123">
              <img src={productImageUrl} alt="KIT Psicología en Fútbol" loading="lazy" decoding="async" className="w-[55%] md:w-[70%] max-w-[220px] drop-shadow-2xl mb-4" data-id="element-124" />
              <h3 className="text-xl font-display font-bold text-white mb-1" data-id="element-125">
                KIT PSICOLOGÍA EN FÚTBOL™
              </h3>
              <p className="text-green-400 text-sm font-medium mb-4" data-id="element-126">
                Acceso inmediato y de por vida
              </p>

              <ul className="text-left text-gray-300 space-y-1.5 w-full max-w-xs mx-auto text-xs" data-id="element-127">
                <li className="flex items-center" data-id="element-128">
                  <Check size={14} className="text-green-400 mr-2 flex-shrink-0" data-id="element-129" />{' '}
                  8 módulos profesionales
                </li>
                <li className="flex items-center" data-id="element-130">
                  <Check size={14} className="text-green-400 mr-2 flex-shrink-0" data-id="element-131" />{' '}
                  Protocolo Mental Post Error
                </li>
                <li className="flex items-center" data-id="element-132">
                  <Check size={14} className="text-green-400 mr-2 flex-shrink-0" data-id="element-133" />{' '}
                  Rutina Pre Partido para Futbolistas
                </li>
                <li className="flex items-center" data-id="element-134">
                  <Check size={14} className="text-green-400 mr-2 flex-shrink-0" data-id="element-135" />{' '}
                  Guía de Reunión Grupal para Equipos
                </li>
                <li className="flex items-center" data-id="element-136">
                  <Check size={14} className="text-green-400 mr-2 flex-shrink-0" data-id="element-137" />{' '}
                  Herramientas, plantillas y protocolos
                </li>
              </ul>
            </div>

            <div className="md:w-1/2 p-6 bg-white flex flex-col justify-center" data-id="element-138">
              <CountdownTimer data-id="element-139" />

              <div className="text-center my-4" data-id="element-140">
                <div className="inline-flex items-center justify-center bg-red-100 text-red-600 px-3 py-1 rounded-full text-xs font-bold mb-2" data-id="element-141">
                  <Clock size={14} className="mr-1.5" data-id="element-142" />
                  Oferta por tiempo limitado
                </div>

                <div data-id="element-143">
                  <span className="text-gray-400 text-lg line-through font-bold" data-id="element-144">
                    $49.990
                  </span>
                </div>
                <div className="text-4xl font-display font-bold text-neutral-900" data-id="element-145">
                  $19.990{' '}
                  <span className="text-base text-gray-500 font-sans font-normal" data-id="element-146">
                    ARS
                  </span>
                </div>
                <p className="text-xs text-gray-500 mt-1" data-id="element-147">
                  Pago único. Sin suscripciones.
                </p>
              </div>

              <a href={checkoutLink} className="block w-full bg-green-500 hover:bg-green-400 text-neutral-900 font-bold text-lg py-4 px-6 rounded-xl shadow-[0_10px_20px_rgba(34,197,94,0.3)] hover:shadow-[0_15px_30px_rgba(34,197,94,0.4)] transition-all transform hover:-translate-y-1 text-center mb-3" data-id="element-148">
                SÍ, QUIERO EL KIT AHORA
              </a>

              <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-gray-600 font-medium" data-id="element-149">
                <span className="flex items-center" data-id="element-150">
                  <ShieldCheck size={14} className="mr-1 text-green-500" data-id="element-151" /> Pago
                  único
                </span>
                <span className="flex items-center" data-id="element-152">
                  <Download size={14} className="mr-1 text-green-500" data-id="element-153" /> Acceso
                  inmediato
                </span>
                <span className="flex items-center" data-id="element-154">
                  <Star size={14} className="mr-1 text-green-500" data-id="element-155" /> Garantía 7
                  días
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-16 px-4 bg-neutral-50" data-id="element-156">
        <div className="max-w-5xl mx-auto" data-id="element-157">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-12 text-neutral-900" data-id="element-158">
            Lo que dicen otros profesionales
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-159">
            {[{
            text: 'Me dio una estructura clarísima para trabajar con chicos de inferiores que se frustran rápido. El protocolo post-error es oro puro.',
            name: 'Santiago Robledo',
            city: 'Rosario, Santa Fe'
          }, {
            text: "Siempre sentí que la teoría me quedaba corta cuando el jugador me decía 'me bloqueé en el partido'. Este kit va directo al grano.",
            name: 'Marcos Leguizamón',
            city: 'Córdoba, Córdoba'
          }, {
            text: 'Excelente material. Lo apliqué con un arquero que venía con mucha presión por el resultado y los cambios fueron notables en dos semanas.',
            name: 'Javier Maldonado',
            city: 'CABA, Buenos Aires'
          }, {
            text: 'Las plantillas te ahorran muchísimo tiempo de planificación. Entrás a la sesión sabiendo qué preguntar y cómo intervenir.',
            name: 'Ignacio Ferreyra',
            city: 'La Plata, Buenos Aires'
          }, {
            text: 'La guía para reuniones grupales me salvó. Pude coordinar una charla con el plantel sin que parezca una clase aburrida. Muy práctico.',
            name: 'Pablo Duarte',
            city: 'Mendoza, Mendoza'
          }].map((test, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-160">
                <div className="flex text-yellow-400 mb-3" data-id="element-161">
                  {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-162" />)}
                </div>
                <p className="text-gray-700 mb-4 text-sm italic" data-id="element-163">
                  "{test.text}"
                </p>
                <div data-id="element-164">
                  <p className="font-bold text-neutral-900 text-sm" data-id="element-165">
                    {test.name}
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-166">{test.city}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* FAQ SECTION */}
      <section className="py-20 px-4 bg-white" data-id="element-167">
        <div className="max-w-3xl mx-auto" data-id="element-168">
          <h2 className="text-3xl font-bold text-center mb-10 text-neutral-900" data-id="element-169">
            Preguntas Frecuentes
          </h2>

          <div className="bg-neutral-50 rounded-2xl p-6 md:p-8 border border-neutral-200" data-id="element-170">
            <FAQItem question="¿El pago es único?" answer="Sí, el pago es 100% único. No hay suscripciones mensuales ni cobros ocultos. Pagás una sola vez y tenés acceso de por vida a todo el material y sus futuras actualizaciones." data-id="element-171" />
            <FAQItem question="¿Cómo recibo el material?" answer={<span data-id="element-173">
                  <strong data-id="element-174">MUY IMPORTANTE:</strong> Al momento de la compra
                  ingresás un correo electrónico. Una vez aprobado el pago,{' '}
                  <strong data-id="element-175">
                    el contenido te llega inmediatamente a ese mail
                  </strong>{' '}
                  con las instrucciones de acceso y descarga. Por favor, revisá
                  tu bandeja de SPAM o Promociones por las dudas. Si tenés
                  cualquier inconveniente, podés comunicarte a{' '}
                  <a href="mailto:sectordigital53@gmail.com" className="text-green-600 font-medium hover:underline" data-id="element-176">
                    sectordigital53@gmail.com
                  </a>{' '}
                  y te ayudamos al instante.
                </span>} data-id="element-172" />
            <FAQItem question="¿Reemplaza una formación o supervisión profesional?" answer="No. Este material es una caja de herramientas prácticas y estructuradas diseñadas para complementar tu trabajo. Está dirigido a profesionales de la salud mental y deportiva, y de ninguna manera reemplaza la evaluación médica, la psicología clínica ni la supervisión profesional cuando corresponda." data-id="element-177" />
            <FAQItem question="¿Para quién es exactamente este kit?" answer="Está diseñado para psicólogos deportivos, psicólogos clínicos que empiezan a atender deportistas, coaches deportivos y profesionales de la salud mental que buscan herramientas específicas, prácticas y aplicables al contexto real del fútbol." data-id="element-178" />
            <FAQItem question="¿Desde qué países puedo comprar?" answer="Podés comprar desde cualquier parte del mundo. El precio está expresado en Pesos Argentinos (ARS) para compras locales, pero si estás en otro país, la plataforma de pago hará la conversión automática a tu moneda local o dólares al momento de pagar." data-id="element-179" />
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-neutral-900 text-gray-400 py-12 px-4 text-center text-sm" data-id="element-180">
        <div className="max-w-4xl mx-auto" data-id="element-181">
          <p className="mb-4" data-id="element-182">
            © 2026 KIT Psicología en Fútbol. Todos los derechos reservados.
          </p>
          <p className="mb-4 text-xs max-w-2xl mx-auto leading-relaxed" data-id="element-183">
            Este material está dirigido a profesionales de la salud mental y no
            reemplaza evaluación médica, psicológica clínica ni supervisión
            profesional cuando corresponda.
          </p>
          <p className="text-xs max-w-2xl mx-auto leading-relaxed opacity-75" data-id="element-184">
            Este sitio no es parte del sitio web de Facebook o Meta Inc. Además,
            este sitio NO está respaldado por Facebook de ninguna manera.
          </p>
        </div>
      </footer>
    </div>;
}